import React from "react";
import { transformViewDate } from "utils/date-utils";

import useStyles from "./styles";

interface IProps {
  body: string;
  commentatorName: string;
  updatedOn: string;
}

const CommentItem = (props: IProps) => {
  const { body, updatedOn, commentatorName } = props;

  const classes = useStyles();
  return (
    <div className={classes.commentRoot}>
      <div className={classes.headerRow}>
        <span className={classes.commenterInfo}>{commentatorName}</span>
      </div>
      <div className={classes.row}>
        {transformViewDate(updatedOn, null, "MMM d, yyyy - h:mm a")}
      </div>
      <div className={classes.commentContent}>{body}</div>
    </div>
  );
};

export default React.memo(CommentItem);
